<template>
    <div style="padding:20px;">
        <!-- <div style="text-align:left;"><p
        style="margin-top:20px;font-weight:bold;font-size=16px;color:#606266;">请填写以下表格，打勾选出对上级沟通方式及协作行为感知的重要程度和满意程度：
        </p></div>     -->
        <el-table
        :data="motivation_info"
        :empty-text="emptyText"
        stripe
        border
        style="width:100%;border-radius:5px;"
        v-if="motivation_info.length>0">
            <el-table-column
                prop="motivation"
                label="工作动机"
                min-width="40%">
                <template slot-scope="scope">
                    <span>{{ scope.row.display_num }}、{{ scope.row.motivation }}</span>
                </template>
            </el-table-column>
            <el-table-column
                prop="satisfaction"
                label="满意度"
                min-width="30%">
                <el-table-column
                    prop="relatively_dissatisfied"
                    label="非常不满意"
                    min-width="10%">
                    <template slot="header">
                        <span>非常不满意</span><br><span>(请选择{{ motivation_maxnum_1 }}项)</span>
                    </template>
                    <template slot-scope="scope">
                        <el-checkbox 
                        v-model="scope.row.relatively_dissatisfied_checked" 
                        :disabled="(relatively_dissatisfied_num>=motivation_maxnum_1 && !scope.row.relatively_dissatisfied_checked) || scope.row.quite_satisfied_checked || scope.row.very_satisfied_checked || is_view"
                        @change="chg_choice('relatively_dissatisfied', scope.row.relatively_dissatisfied_checked, scope.row.display_num + '、' + scope.row.motivation)"></el-checkbox>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="quite_satisfied"
                    label="比较满意"
                    min-width="10%">
                    <template slot="header">
                        <span>比较满意</span><br><span>(请选择{{ motivation_maxnum_2 }}项)</span>
                    </template>
                    <template slot-scope="scope">
                        <el-checkbox 
                        v-model="scope.row.quite_satisfied_checked"
                        :disabled="(quite_satisfied_num>=motivation_maxnum_2 && !scope.row.quite_satisfied_checked) || scope.row.relatively_dissatisfied_checked || scope.row.very_satisfied_checked || is_view"
                        @change="chg_choice('quite_satisfied', scope.row.quite_satisfied_checked, scope.row.motivation)"></el-checkbox>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="very_satisfied"
                    label="满意"
                    min-width="10%">
                    <template slot="header">
                        <span>满意</span><br><span>(请选择{{ motivation_maxnum_3 }}项)</span>
                    </template>
                    <template slot-scope="scope">
                        <el-checkbox 
                        v-model="scope.row.very_satisfied_checked"
                        :disabled="(very_satisfied_num>=motivation_maxnum_3 && !scope.row.very_satisfied_checked) || scope.row.relatively_dissatisfied_checked || scope.row.quite_satisfied_checked || is_view"
                        @change="chg_choice('very_satisfied', scope.row.very_satisfied_checked, scope.row.motivation)"></el-checkbox>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column
                prop="importance"
                label="重要性"
                min-width="30%">
                <el-table-column
                    prop="relatively_important"
                    label="不重要"
                    min-width="10%">
                    <template slot="header">
                        <span>不重要</span><br><span>(请选择{{ motivation_maxnum_3 }}项)</span>
                    </template>
                    <template slot-scope="scope">
                        <el-checkbox 
                        v-model="scope.row.relatively_important_checked"
                        :disabled="(relatively_important_num>=motivation_maxnum_3 && !scope.row.relatively_important_checked) || scope.row.quite_important_checked || scope.row.very_important_checked || is_view"
                        @change="chg_choice('relatively_important', scope.row.relatively_important_checked, scope.row.motivation)"></el-checkbox>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="quite_important"
                    label="比较重要"
                    min-width="10%">
                    <template slot="header">
                        <span>比较重要</span><br><span>(请选择{{ motivation_maxnum_2 }}项)</span>
                    </template>
                    <template slot-scope="scope">
                        <el-checkbox 
                        v-model="scope.row.quite_important_checked"
                        :disabled="(quite_important_num>=motivation_maxnum_2 && !scope.row.quite_important_checked) || scope.row.relatively_important_checked || scope.row.very_important_checked || is_view"
                        @change="chg_choice('quite_important', scope.row.quite_important_checked, scope.row.motivation)"></el-checkbox>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="very_important"
                    label="非常重要"
                    min-width="10%">
                    <template slot="header">
                        <span>非常重要</span><br><span>(请选择{{ motivation_maxnum_1 }}项)</span>
                    </template>
                    <template slot-scope="scope">
                        <el-checkbox 
                        v-model="scope.row.very_important_checked"
                        :disabled="(very_important_num>=motivation_maxnum_1 && !scope.row.very_important_checked) || scope.row.relatively_important_checked || scope.row.quite_important_checked || is_view"
                        @change="chg_choice('very_important', scope.row.very_important_checked, scope.row.display_num + '、' + scope.row.motivation)"></el-checkbox>
                    </template>
                </el-table-column>
            </el-table-column>
        </el-table>
        <!-- 20240831两个排序的表格暂时屏蔽 -->
        <!-- <div style="text-align:left;"><p 
        v-if="relatively_dissatisfied_num==motivation_maxnum_3"
        style="margin-top:20px;font-size:16px;color:#67C23A;">请对以下动机按照相对不满意的程度进行排序，1为最不满意：
        </p></div>
        <el-table
        :data="relatively_dissatisfied_motivations"
        stripe
        border
        style="width: 100%"
        v-if="relatively_dissatisfied_num==motivation_maxnum_3">
            <el-table-column
                prop="motivation_desc"
                label="“相对不满意”的动机（示例）"
                min-width="45%">
            </el-table-column>
            <el-table-column
                prop="sorted_options"
                label="排序"
                min-width="55%">
                <template slot-scope="scope">
                    <el-radio-group v-model="scope.row.sorted_num">
                        <template v-for="(option, index) in relatively_dissatisfied_motivations">
                            <el-radio :label=(index+1) :key=index :disabled="is_view">{{ index+1 }}</el-radio>
                        </template>
                    </el-radio-group>
                </template>
            </el-table-column>
        </el-table>
        <div style="text-align:left;"><p 
        v-if="very_important_num==motivation_maxnum_1"
        style="margin-top:20px;font-size:16px;color:#67C23A;">请对以下动机按照重要的程度进行排序，1为最重要：
        </p></div>
        <el-table
        :data="very_important_motivations"
        stripe
        border
        style="width: 100%"
        v-if="very_important_num==motivation_maxnum_1">
            <el-table-column
                prop="motivation_desc"
                label="“非常重要”的动机（示例）"
                min-width="45%">
            </el-table-column>
            <el-table-column
                prop="sorted_options"
                label="排序"
                min-width="55%">
                <template slot-scope="scope">
                    <el-radio-group v-model="scope.row.sorted_num">
                        <template v-for="(option, index) in very_important_motivations">
                            <el-radio :label=(index+1) :key=index :disabled="is_view">{{ index+1 }}</el-radio>
                        </template>
                    </el-radio-group>
                </template>
            </el-table-column>
        </el-table> -->
    </div>   
</template>

<script>
import postdata from "@/api/postData.js";
import getdata from "@/api/getData.js";
export default {
    // 组件传递的prop数据，会在beforeUpdate钩子期间生效！
    // beforeUpdate() {
    //     if(this.question_info.length <= 0){
    //         this.display_flag = true;
    //     }else{
    //         // 这里要增加else的处理，在导入模板后更新display_flag的值，因为没有重新加载页面，所以此时的display_flag不会从重置为初始值false开始判断
    //         this.display_flag = false;
    //     }
    // },
    data() {
        return {
            template_file: {
                file_name: 'motivation_template.xlsx'
            },
            formInline: {
                search_info: '',
                search_result: [],
            },
            display_flag: false,
            emptyText: '暂无工作动机信息，请先导入。',
            relatively_dissatisfied_num: 0,
            quite_satisfied_num: 0,
            very_satisfied_num: 0,
            relatively_important_num: 0,
            quite_important_num: 0,
            very_important_num: 0,
            relatively_dissatisfied_motivations: [],
            very_important_motivations: [],
            motivation_maxnum_1: 999,
            motivation_maxnum_2: 999,
            motivation_maxnum_3: 999,
            motivation_info: [],
            motivation_finish_flag: false,
        }
    },
    props: ["is_view"],
    // props: ['task_id'],
    // 由于relatively_dissatisfied_motivations和very_important_motivations需要传空数组，而Object/Array类型不能直接定义空对象或空数组，必须使用 工厂函数 return 回一个默认值（即通过prop复杂对象模式中的default返回）
    // props: {
    //     motivation_info: {
    //         type: Array,
    //         required: true,
    //     },
    //     relatively_dissatisfied_motivations: {
    //         type: Array,
    //         default: () => []
    //     },
    //     very_important_motivations: {
    //         type: Array,
    //         default: () => []
    //     },
    //     motivation_maxnum_1: {
    //         type: Number,
    //         required: true,
    //     },
    //     motivation_maxnum_2: {
    //         type: Number,
    //         required: true,
    //     },
    //     motivation_maxnum_3: {
    //         type: Number,
    //         required: true,
    //     },
    //     relatively_dissatisfied_num: {
    //         type: Number,
    //         required: true,
    //     },
    //     quite_satisfied_num: {
    //         type: Number,
    //         required: true,
    //     },
    //     very_satisfied_num: {
    //         type: Number,
    //         required: true,
    //     },
    //     relatively_important_num: {
    //         type: Number,
    //         required: true,
    //     },
    //     quite_important_num: {
    //         type: Number,
    //         required: true,
    //     },
    //     very_important_num: {
    //         type: Number,
    //         required: true,
    //     },
    //     error_flag: {
    //         type: Boolean,
    //     }
    // },
    // props: ['motivation_info', 'motivation_maxnum_1', 'motivation_maxnum_2', 'motivation_maxnum_3', 'relatively_dissatisfied_num', 'quite_satisfied_num', 'very_satisfied_num', 'relatively_important_num', 'quite_important_num', 'very_important_num', 'relatively_dissatisfied_motivations', 'very_important_motivations', 'error_flag'],
    // props: ['motivation_info_props', 'error_flag'],
    // watch:{
    //     motivation_maxnum_1(news, olds){
    //         console.log('change!');
    //         this.$nextTick(() => {
    //             // this.motivation_info = news[0];
    //             this.motivation_maxnum_1 = news;
    //             // this.motivation_maxnum_2 = news[2];
    //             // this.motivation_maxnum_3 = news[3];
    //             // this.relatively_dissatisfied_num = news[4];
    //             // this.quite_satisfied_num = news[5];
    //             // this.very_satisfied_num = news[6];
    //             // this.relatively_important_num = news[7];
    //             // this.quite_important_num = news[8];
    //             // this.very_important_num = news[9];
    //             // this.relatively_dissatisfied_motivations = news[10];
    //             // this.very_important_motivations = news[11];
    //             // this.$forceUpdate();
    //         })
    //     },
    //     motivation_maxnum_2(news, olds){
    //         console.log('change!');
    //         this.$nextTick(() => {
    //             this.motivation_maxnum_2 = news;
    //         })
    //     },
    //     motivation_maxnum_3(news, olds){
    //         console.log('change!');
    //         this.$nextTick(() => {
    //             this.motivation_maxnum_3 = news;
    //         })
    //     },
    // },
    methods: {
        submitMotivationResults(api_name) {
            // api_name: saveMotivationResults or submitMotivationResults
            let params = {
                'task_id': this.task_id,
            };
            postdata.postListP(api_name, JSON.stringify(this.motivation_info), params)
            .then(resp => {
                if(resp.data.code == 200){
                    this.$message({
                    message: '保存成功！',
                    type: "success",
                    })
                }
            })
            .catch(err => {
                console.log(err);
            })           
        },
        // 获取RC工作动机问卷     
        getRCMotivation(task_id) {
            let params = {
                task_id: task_id,
            }
            getdata.getListP("getRCMotivation", params)
            .then(resp => {
                if(resp.data.code == 200){
                    this.motivation_info = resp.data.data[0];
                    this.motivation_maxnum_1 = resp.data.data[1];
                    this.motivation_maxnum_2 = resp.data.data[2];
                    this.motivation_maxnum_3 = resp.data.data[3];
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
        // 获取已保存的RC工作动机问卷
        getRCMotivationResults(task_id, user_id) {
            let params = {
                task_id: task_id,
                user_id: user_id,
            }
            getdata.getListP("getMotivationResults", params)
            .then(resp => {
                if(resp.data.code == 200){
                    this.motivation_info = resp.data.data[0];
                    this.relatively_dissatisfied_motivations = resp.data.data[1];
                    this.very_important_motivations = resp.data.data[2];
                    this.relatively_dissatisfied_num = resp.data.data[3];
                    this.quite_satisfied_num = resp.data.data[4];
                    this.very_satisfied_num = resp.data.data[5];
                    this.relatively_important_num = resp.data.data[6];
                    this.quite_important_num = resp.data.data[7];
                    this.very_important_num = resp.data.data[8];
                    this.motivation_maxnum_1 = resp.data.data[9];
                    this.motivation_maxnum_2 = resp.data.data[10];
                    this.motivation_maxnum_3 = resp.data.data[11];
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
        chg_choice(type, status, motivation) {
            if(type=="relatively_dissatisfied"){
                if(status==true){
                    this.relatively_dissatisfied_num += 1;
                    console.log("relatively_dissatisfied_num: " + this.relatively_dissatisfied_num);
                    console.log("motivation_maxnum_3: " + this.motivation_maxnum_3);
                    console.dir(this.relatively_dissatisfied_motivations);
                    this.relatively_dissatisfied_motivations.push({'motivation_desc': motivation, 'sorted_num': null});
                    console.dir(this.relatively_dissatisfied_motivations);
                }else{
                    this.relatively_dissatisfied_num -= 1;
                    this.relatively_dissatisfied_motivations.pop();
                }
            }
            if(type=="quite_satisfied"){
                if(status==true){
                    this.quite_satisfied_num += 1;
                    console.log("quite_satisfied_num: " + this.quite_satisfied_num);
                    console.log("motivation_maxnum_2: " + this.motivation_maxnum_2);
                }else{
                    this.quite_satisfied_num -= 1;
                    console.log("quite_satisfied_num: " + this.quite_satisfied_num);
                    console.log("motivation_maxnum_2: " + this.motivation_maxnum_2);
                }
            }
            if(type=="very_satisfied"){
                if(status==true){
                    this.very_satisfied_num += 1;
                }else{
                    this.very_satisfied_num -= 1;
                }
            }
            if(type=="relatively_important"){
                if(status==true){
                    this.relatively_important_num += 1;
                }else{
                    this.relatively_important_num -= 1;
                }
            }
            if(type=="quite_important"){
                if(status==true){
                    this.quite_important_num += 1;
                }else{
                    this.quite_important_num -= 1;
                }
            }
            if(type=="very_important"){
                if(status==true){
                    this.very_important_num += 1;
                    this.very_important_motivations.push({'motivation_desc': motivation, 'sorted_num': null});
                }else{
                    this.very_important_num -= 1;
                    this.very_important_motivations.pop();
                }
            }
            if(this.relatively_dissatisfied_num == this.motivation_maxnum_1 && this.quite_satisfied_num == this.motivation_maxnum_2 && this.very_satisfied_num == this.motivation_maxnum_3 && this.relatively_important_num == this.motivation_maxnum_3 && this.quite_important_num == this.motivation_maxnum_2 && this.very_important_num == this.motivation_maxnum_1){
                this.motivation_finish_flag = true;
            }
            else{
                this.motivation_finish_flag = false;
            }
        },
        Download_template() {
            postdata.downloadFiles("download", JSON.stringify(this.template_file))
              .then(resp => {
                // 将流文件通过浏览器下载，这里使用整个后台返回的response，供download函数提取data、headers等信息
                this.download(resp);
              })
              .catch(err => {
                console.log(err);
              })
        },
        download (res) {
            let blob = new Blob([res.data], { type: "application/vnd.ms-excel" });//type是文件类，详情可以参阅blob文件类型
            // 创建新的URL并指向File对象或者Blob对象的地址
            const blobURL = window.URL.createObjectURL(blob)
            // 创建a标签，用于跳转至下载链接
            const tempLink = document.createElement('a')
            tempLink.style.display = 'none'
            tempLink.href = blobURL
            tempLink.setAttribute('download', decodeURI(res.headers['content-disposition'].split(';')[1].split('=')[1]))
            // 兼容：某些浏览器不支持HTML5的download属性
            if (typeof tempLink.download === 'undefined') {
                tempLink.setAttribute('target', '_blank')
            }
            // 挂载a标签
            document.body.appendChild(tempLink)
            tempLink.click()
            document.body.removeChild(tempLink)
            // 释放blob URL地址
            window.URL.revokeObjectURL(blobURL)
        },
        // 向父组件传递问卷测评结果
        submitMotivation() {
            this.$emit('sendData', [this.motivation_info, 'submit', this.relatively_dissatisfied_motivations, this.very_important_motivations, this.motivation_finish_flag]);
        },
        saveMotivation() {
            this.$emit('sendData', [this.motivation_info, 'save', this.relatively_dissatisfied_motivations, this.very_important_motivations]);
        },
    }
}
</script>

<style scoped>
.el-table /deep/ th.el-table__cell {
    background-color: #f5f7fa;
}
</style>